export const MU_SET_JOB_TYPES = 'mutations/jobAd/jobTypes'
export const MU_SET_CANCELTOKENSOURCE = 'mutations/jobAd/canceltoken'
export const MU_SET_PORTER_VALUES = 'mutations/jobAd/porterValues'
